/* Lights Out Subscribe – Black Friday lander: countdown, ship dates, subscribe add-to-cart + discount code */
(function () {
  if (window.__losInit) return;
  window.__losInit = true;
  var CFG = null;
  function load() { var el = document.getElementById("los-config"); try { CFG = el ? JSON.parse(el.textContent) : {}; } catch (e) { CFG = {}; } }
  function cfg() { if (!CFG) load(); return CFG; }
  function fill() {
    var m = cfg().money || {}, p = cfg().pct || {};
    document.querySelectorAll("[data-los-m]").forEach(function (el) { var k = el.getAttribute("data-los-m"); if (m[k] != null) el.textContent = m[k]; });
    document.querySelectorAll("[data-los-pct]").forEach(function (el) { var k = el.getAttribute("data-los-pct"); if (p[k] != null) el.style.width = p[k] + "%"; });
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function parts() {
    var end = Date.parse(cfg().end);
    var ms = isNaN(end) ? 0 : Math.max(0, end - Date.now());
    return { ms: ms, d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 };
  }
  function tick() {
    var p = parts();
    document.querySelectorAll('[data-los-countdown]').forEach(function (el) {
      var kind = el.getAttribute('data-los-countdown');
      if (kind === 'short') el.textContent = p.d > 0 ? p.d + 'd ' + pad(p.h) + 'h' : pad(p.h) + ':' + pad(p.m) + ':' + pad(p.s);
      else if (kind === 'long') el.textContent = p.d > 0 ? p.d + ' day' + (p.d === 1 ? '' : 's') : p.h + ' hour' + (p.h === 1 ? '' : 's');
      else if (kind === 'clock') {
        ['d', 'h', 'm', 's'].forEach(function (k) { var n = el.querySelector('[data-los-cd="' + k + '"]'); if (n) n.textContent = pad(p[k]); });
      }
    });
  }
  function dates() {
    document.querySelectorAll('[data-los-date]').forEach(function (el) {
      if (!el.dataset.tpl) el.dataset.tpl = el.textContent;
      var days = Number(el.getAttribute('data-los-date')) || 0;
      var d = new Date(Date.now() + days * 864e5).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      el.textContent = el.dataset.tpl.replace(/\[date\]/g, d);
    });
  }
  function announce(msg) {
    var r = document.querySelector('[data-los-status]');
    if (!r) return;
    r.textContent = '';
    requestAnimationFrame(function () { r.textContent = msg; });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Error'); return d; }); });
  }
  function done(btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); delete btn.dataset.busy; }
  function addToCart(btn) {
    var c = cfg();
    if (btn.dataset.busy) return;
    if (!c.variantId) { announce(c.msgUnavailable || 'This product is not available right now.'); return; }
    btn.dataset.busy = '1';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var code = (c.code || '').trim();
    var dest = c.redirect === 'cart' ? '/cart' : '/checkout';
    var item = { id: Number(c.variantId), quantity: 1 };
    if (c.sellingPlan) item.selling_plan = Number(c.sellingPlan);
    post('/cart/add.js', { items: [item] })
      .then(function () {
        if (!code) return;
        return post('/cart/update.js', { discount: code }).catch(function () {});
      })
      .then(function () {
        announce(c.msgAdded || 'Added to cart.');
        /* /discount/CODE stores the code on the session and cart, then forwards to checkout or cart */
        window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest) : dest;
      })
      .catch(function (e) { done(btn); announce((e && e.message) || c.msgError || 'Sorry, something went wrong. Please try again.'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-los-atc]');
    if (b) { e.preventDefault(); addToCart(b); }
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-los-atc].is-loading').forEach(done);
  });
  function init() {
    load(); fill(); tick(); dates();
    if (document.querySelector('[data-los-sticky]')) document.body.classList.add('los-has-sticky');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  setInterval(tick, 1000);
})();
